/**
 * Converts conditions-based ad units object to ad target array format
 * @param conditionsBasedAdUnits - Object with pub_meta keys and values
 * @returns Array of [key, value] tuples for ad targeting
 */
const convertConditionsBasedAdUnitsToAdTargets = (
  conditionsBasedAdUnits: Record<string, string> | null,
): [string, string][] => {
  if (!conditionsBasedAdUnits) {
    return [];
  }

  const adTargets: [string, string][] = [];

  if (conditionsBasedAdUnits.pub_meta_2) {
    adTargets.push(['airTemperature', conditionsBasedAdUnits.pub_meta_2]);
  }
  if (conditionsBasedAdUnits.pub_meta_3) {
    adTargets.push(['windSpeed', conditionsBasedAdUnits.pub_meta_3]);
  }
  if (conditionsBasedAdUnits.pub_meta_5) {
    adTargets.push(['sst', conditionsBasedAdUnits.pub_meta_5]);
  }
  if (conditionsBasedAdUnits.pub_meta_8) {
    adTargets.push(['surfHeight', conditionsBasedAdUnits.pub_meta_8]);
  }
  if (conditionsBasedAdUnits.pub_meta_9) {
    adTargets.push(['conditionsRating', conditionsBasedAdUnits.pub_meta_9]);
  }

  return adTargets;
};

export default convertConditionsBasedAdUnitsToAdTargets;
